import styled from "styled-components";
import { COLORS, fontMixin } from "../../../../styles";

export const Container = styled.div`
	display: grid;
`;

export const FormWrapper = styled.form`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 15px 30px;

	[data-input]:first-child {
		grid-column: 1 / span 2;
	}

	[data-action] {
		grid-column: 1 / span 2;
	}
`;

export const Actions = styled.div`
	display: flex;
	justify-content: flex-end;
`;

export const SuccessBox = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 14px;
`;

export const SuccessText = styled.div`
	${fontMixin({ size: 14 })};
	color: ${COLORS.Dark_Gray};
`;

export const SuccessEmail = styled.div`
	${fontMixin({
	size: 16,
	weight: 600,
})};

	color: ${COLORS.Black};
`;
